export default class FarloUiRevolverFlickityCarousel {
	constructor(element) {
		this.flkty = new Flickity(element, {
			cellAlign: 'center',
			pageDots: false,
			prevNextButtons: false,
			wrapAround: true,
			groupCells: true,
			autoPlay: 5000,
			dragThreshold: 1,
			draggable: true,
		});
	}
}
